<template>
  <li
    class="flex gap-3 rounded-2xl border p-3 shadow-sm transition"
    :class="active ? 'border-emerald-200 bg-emerald-50' : 'border-gray-200 bg-white'"
  >
    <div class="mt-1">
      <span
        class="inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold transition-colors"
        :class="active ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-700'"
        >{{ index + 1 }}</span
      >
    </div>

    <div class="flex-1">
      <div class="flex items-center justify-between">
        <p class="font-semibold text-gray-900">{{ title }}</p>
        <svg
          v-if="active"
          viewBox="0 0 24 24"
          class="h-5 w-5 text-emerald-600"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M9.55 17.54 4.5 12.5l1.4-1.4 3.65 3.63 8.55-8.54 1.4 1.41z"
          />
        </svg>
      </div>
      <p class="text-sm text-gray-600">{{ desc }}</p>

      <!-- Chips: animate as ONE block to avoid snap on leave -->

      <ul key="on" class="mt-3 flex flex-wrap gap-2">
        <li
          v-for="f in features"
          :key="title + f"
          class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-medium text-gray-700 shadow-sm transition-all duration-300"
        >
          <span
            class="inline-block h-1.5 w-1.5 rounded-full transition-colors"
            :class="active ? 'bg-emerald-500' : 'bg-gray-300'"
          ></span>
          {{ f }}
        </li>
      </ul>
    </div>
  </li>
</template>

<script setup>
const props = defineProps({
  index: Number,
  title: String,
  desc: String,
  features: Array,
  active: Boolean,
});
</script>
